export enum RozetkaSenderTypeEnum {
    NATURAL = 'natural',
    LEGAL = 'legal'
}
